import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // cmr
    cmrEmit: {
      tableData: [],
      totalCmrsEmit: 0
    },
    queryCmrEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersCmrEmit: [],

    // Combo estados cmr
    optionsFilterStatusCmr: [],
    optionsFilterReceiverCmrEmit: [],
    optionsFilterSenderCmrEmit: [],

    // Datos Select Filtros cmr
    optionsFilterDateCreationCmrEmit: [],
    optionsFilterDateIssueCmrEmit: [],
    optionsFilterDeliveryNumberCmrEmit: [],
    optionsFilterDeliveryDateCmrEmit: [],

  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla cmr
    isShowNumberCmrEmit: true,
    isShowOrderCmrEmit: false,
    isShowGroupCmrEmit: false,
    isShowVehiclePlateCmrEmit: true,
    isShowTrailerPlateCmrEmit: true,
    isShowSenderPartyCmrEmit: true,
    isShowSenderCentreCmrEmit: true,
    isShowReceiverPartyCmrEmit: true,
    isShowReceiverCentreCmrEmit: true,
    isShowCreationDateTimeCmrEmit: true,
    isShowStatusCmrEmit: true,
    isShowServiceCmrEmit: true,
    isShowSendDateCmrEmit: true,
    isShowTransportistCmrEmit: true,
    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesCmrEmit: true,
    
  
  }
  return local
}
function setByUserLocalCMR () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr) {
    const local = {
      // Columnas Tabla cmr
      isShowNumberCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowNumberCmrEmit,
      isShowOrderCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowOrderCmrEmit,
      isShowGroupCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowGroupCmrEmit,
      isShowVehiclePlateCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowVehiclePlateCmrEmit,
      isShowTrailerPlateCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowTrailerPlateCmrEmit,
      isShowSenderPartyCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowSenderPartyCmrEmit,
      isShowSenderCentreCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowSenderCentreCmrEmit,
      isShowReceiverPartyCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowReceiverPartyCmrEmit,
      isShowReceiverCentreCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowReceiverCentreCmrEmit,
      isShowCreationDateTimeCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowCreationDateTimeCmrEmit,
      isShowStatusCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowStatusCmrEmit,
      isShowServiceCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowServiceCmrEmit,
      isShowSendDateCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowSendDateCmrEmit,
      isShowTransportistCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowTransportistCmrEmit,
      // Columnas tabla lineas emitidas
      isShowItemCodeLinesCmrEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr.isShowItemCodeLinesCmrEmit,
     
      }
    return local
  } else {
    return initLocal()
  }
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla cmr
    isShowNumberCmrEmit: true,
    isShowOrderCmrEmit: false,
    isShowGroupCmrEmit: false,
    isShowVehiclePlateCmrEmit: true,
    isShowTrailerPlateCmrEmit: true,
    isShowSenderPartyCmrEmit: true,
    isShowSenderCentreCmrEmit: true,
    isShowReceiverPartyCmrEmit: true,
    isShowReceiverCentreCmrEmit: true,
    isShowCreationDateTimeCmrEmit: true,
    isShowStatusCmrEmit: true,
    isShowServiceCmrEmit: true,
    isShowSendDateCmrEmit: true,
    isShowTransportistCmrEmit: true,
    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesCmrEmit: true,
    
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla cmr
  cmrEmit: state => {
    return state.session.cmrEmit
  },
  queryCmrEmit: state => {
    return state.session.queryCmrEmit
  },
  listSelectedFiltersCmrEmit: state => {
    return state.session.listSelectedFiltersCmrEmit
  },


  // Datos Select Filtros cmr
  optionsFilterDateCreationCmrEmit: state => {
    return state.session.optionsFilterDateCreationCmrEmit
  },
  optionsFilterDateIssueCmrEmit: state => {
    return state.session.optionsFilterDateIssueCmrEmit
  },
  optionsFilterDeliveryDateCmrEmit: state => {
    return state.session.optionsFilterDeliveryDateCmrEmit
  },  
  optionsFilterDeliveryNumberCmrEmit: state => {
    return state.session.optionsFilterDeliveryNumberCmrEmit
  },

  // Combo estados
  optionsFilterStatusCmr: state => {
    return state.session.optionsFilterStatusCmr
  },
  optionsFilterReceiverCmrEmit: state => {
    return state.session.optionsFilterReceiverCmrEmit
  },
  optionsFilterSenderCmrEmit: state => {
    return state.session.optionsFilterSenderCmrEmit
  },

  // Columnas Tabla cmr
  isShowNumberCmrEmit: state => {
    return state.local.isShowNumberCmrEmit
  },
  isShowOrderCmrEmit: state => {
    return state.local.isShowOrderCmrEmit
  },
  isShowGroupCmrEmit: state => {
    return state.local.isShowGroupCmrEmit
  },
  isShowVehiclePlateCmrEmit: state => {
    return state.local.isShowVehiclePlateCmrEmit
  },
  isShowTrailerPlateCmrEmit: state => {
    return state.local.isShowTrailerPlateCmrEmit
  },
  isShowSenderPartyCmrEmit: state => {
    return state.local.isShowSenderPartyCmrEmit
  },
  isShowSenderCentreCmrEmit: state => {
    return state.local.isShowSenderCentreCmrEmit
  },
  isShowReceiverPartyCmrEmit: state => {
    return state.local.isShowReceiverPartyCmrEmit
  },
  isShowReceiverCentreCmrEmit: state => {
    return state.local.isShowReceiverCentreCmrEmit
  },
  isShowCreationDateTimeCmrEmit: state => {
    return state.local.isShowCreationDateTimeCmrEmit
  },
  isShowStatusCmrEmit: state => {
    return state.local.isShowStatusCmrEmit
  },
  isShowServiceCmrEmit: state => {
    return state.local.isShowServiceCmrEmit
  },
  isShowSendDateCmrEmit: state => {
    return state.local.isShowSendDateCmrEmit
  },
  isShowTransportistCmrEmit: state => {
    return state.local.isShowTransportistCmrEmit
  },


  // Columnas lineas pedido emitidas
  isShowItemCodeLinesCmrEmit: state => {
    return state.local.isShowItemCodeLinesCmrEmit
  }

}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameCMR ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCMR()
    }
  },
  async isNewVersionCmrLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.cmr)
    return isnew
  },

  /* CMR */
  /**
  * Servicio para traer los cmr  .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getCmrNotes ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/cmr/searchCMRweb',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('CMR_EMIT_STATE', {
        tableData: response.data.content,
        totalCmrsEmit: response.data.totalElements
      })


      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener eventos de un cmr
   */
   async getCmrEvents ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/getevent?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /**
   * Servicio para obtener eventos de un cmr
   */
   async getCmrHistory ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/gethistory?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de un CMR
  async getCmrDetail ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/cmrdetail?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

/**
 * Servicio para descargar zip con los PDF de los cmr indicados
 * @param {*} cmrIds
 */
    async downloadCmrPdfMultiple ({ commit, state }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/cmr/pdf',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            cmrIds: params.cmrIds,
            searchType: params.searchType
          },
          responseType: 'blob',
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })
  
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        let filename = 'pdfs-cmr.zip'
        const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
        if (fileGroup && fileGroup[2]) {
          filename = fileGroup[2]
        }
        FileSaver.saveAs(blob, filename)
  
        fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
        return filename
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },
   /**
 * Servicio para descargar pdf de un cmr
 * @param {*} cmrId
 */
   async downloadCmrHistoryPdf ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/' + params.cmrHistoryId + '/pdfhistory',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'cmr.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   /**
 * Servicio para descargar original de un cmr
 * @param {*} cmrId
 */
    async downloadCmrOriginal ({ commit, state }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/cmr/' + params.cmrId + '/original',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            searchType: params.searchType
          },
          responseType: 'blob'
        })
  
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        let filename = 'cmr.pdf'
        const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
        if (fileGroup && fileGroup[2]) {
          filename = fileGroup[2]
        }
        FileSaver.saveAs(blob, filename)
  
        fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
        return filename
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

     /**
     * Servicio para descargar Original Firmado de una carta de porte
     * @param {*} cmrId
     */
  async downloadCmrFormatted ({
    commit,
    rootState
  }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/' + cmrId + '/originalformatted',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'cmr-original'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /**
 * Servicio para descargar attach de un cmr
 * @param {*} attachId
 */
    async downloadCmrAttach ({ commit, state }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/cmr/' + params.attachId + '/attach',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            fileName: params.fileName
          },
          responseType: 'blob'
        })
  
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        let filename = 'cmr.pdf'
        const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
        if (fileGroup && fileGroup[2]) {
          filename = fileGroup[2]
        }
        FileSaver.saveAs(blob, filename)
  
        fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
        return filename
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },
    /**
     * Servicio para modificar los datos de una carta de porte
     * @param {*} params
     */
  async modifyCmr ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/cmr/' + params.cmrId,
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          cmrNumber: params.cmrNumber,
          chargerObservations: params.chargerObservations,
          nameTransportist: params.nameTransportist,
          emailTransportist: params.emailTransportist,
          nifTransportist: params.nifTransportist,
          transportistObservations: params.transportistObservations,
          vehiclePlate: params.vehiclePlate,
          trailerPlate: params.trailerPlate,
          statusCode: params.statusCode,
          observations: params.observations
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadCmrMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/' + params.cmrId + '/metadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'cmr-metadata'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de estados de cmrs
   */
  async getOptionsFilterStatusCmr ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/cmr/cmrstatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterStatusCmr = response.data
      commit('OPTIONS_FILTER_STATUS_CMR', optionsFilterStatusCmr)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusCmr
    } catch (error) {
      console.log('status cmr : ', error)
      throw error.response
    }
  },
  
  /**
     * Servicio para Exportar Todas las cmr  a CSV
     */
  async downloadCmrCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        url: '/cmr/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'cmr.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla cmr Emitidas
  cmrsEmitState: ({ commit }, payload) => {
    commit('CMR_EMIT_STATE', payload)
  },
  queryCmrEmitState: ({ commit }, payload) => {
    commit('QUERY_CMR_EMIT_STATE', payload)
  },
  listSelectedFiltersCmrEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_CMR_EMIT_STATE', payload)
  },

 
  // Datos Select Filtros cmr Emitidas
  optionsFilterDateCreationCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_CMR_EMIT', payload)
  },
  optionsFilterDateIssueCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_CMR_EMIT', payload)
  },
  optionsFilterDeliveryDateCmrEmitState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATE_CMR_EMIT', payload)
  },  
  optionsFilterDeliveryNumberCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_NUMBER_CMR_EMIT', payload)
  },


  // Combo estados
  optionsFilterStatusCmrState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_CMR', payload)
  },
  optionsFilterReceiverCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_RECEIVER_CMR_EMIT', payload)
  },
  optionsFilterSenderCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SENDER_CMR_EMIT', payload)
  },

  // Columnas Tabla cmr
  isShowNumberCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUMBER_CMR_EMIT', payload)
  },
  isShowOrderCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_CMR_EMIT', payload)
  },
  isShowGroupCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_GROUP_CMR_EMIT', payload)
  },
  isShowVehiclePlateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_VEHICLE_PLATE_CMR_EMIT', payload)
  },
  isShowTrailerPlateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_TRAILER_PLATE_CMR_EMIT', payload)
  },
  isShowSenderPartyCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SENDER_PARTY_CMR_EMIT', payload)
  },
  isShowSenderCentreCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SENDER_CENTRE_CMR_EMIT', payload)
  },
  isShowReceiverPartyCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVER_PARTY_CMR_EMIT', payload)
  },
  isShowReceiverCentreCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVER_CENTRE_CMR_EMIT', payload)
  },
  isShowCreationDateTimeCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATION_DATE_CMR_EMIT', payload)
  },
  isShowStatusCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_CMR_EMIT', payload)
  },
  isShowServiceCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_CMR_EMIT', payload)
  },
  isShowSendDateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SEND_DATE_CMR_EMIT', payload)
  },
  isShowTransportistCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_TRANSPORTIST_CMR_EMIT', payload)
  },
    
  // Columnas lineas emitidas
  isShowItemCodeLinesCmrEmittAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_CMR_EMIT', payload)
  },  
}

// mutations
const mutations = {
  resetSessionCmr (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  cmrDatesSuperAdmin (state) {
    state.session.queryCmrEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryCmrsReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // cmr
  'CMR_EMIT_STATE' (state, payload) {
    state.session.cmrEmit = payload
  },
  'QUERY_CMR_EMIT_STATE' (state, payload) {
    state.session.queryCmrEmit = payload
  },
  'LIST_SELECTED_FILTERS_CMR_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersCmrEmit = payload
  },


  // Datos Select Filtros cmr
  'OPTIONS_FILTER_DATE_CREATION_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationCmrEmit = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDateIssueCmrEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATE_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryDateCmrEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_NUMBER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryNumberCmrEmit = payload
  },

  // Combo estados cmr
  'OPTIONS_FILTER_STATUS_CMR' (state, payload) {
    state.session.optionsFilterStatusCmr = payload
  },
  'OPTIONS_FILTER_RECEIVER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterReceiverCmrEmit = payload
  },
  'OPTIONS_FILTER_SENDER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterSenderCmrEmit = payload
  },

  // Columnas Tabla cmr
  'IS_SHOW_NUMBER_CMR_EMIT' (state, payload) {
    state.local.isShowNumberCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowNumberCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_CMR_EMIT' (state, payload) {
    state.local.isShowOrderCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowOrderCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROUP_CMR_EMIT' (state, payload) {
    state.local.isShowGroupCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowGroupCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VEHICLE_PLATE_CMR_EMIT' (state, payload) {
    state.local.isShowVehiclePlateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowVehiclePlateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TRAILER_PLATE_CMR_EMIT' (state, payload) {
    state.local.isShowTrailerPlateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowTrailerPlateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENDER_PARTY_CMR_EMIT' (state, payload) {
    state.local.isShowSenderPartyCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSenderPartyCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENDER_CENTRE_CMR_EMIT' (state, payload) {
    state.local.isShowSenderCentreCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSenderCentreCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVER_PARTY_CMR_EMIT' (state, payload) {
    state.local.isShowReceiverPartyCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowReceiverPartyCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVER_CENTRE_CMR_EMIT' (state, payload) {
    state.local.isShowReceiverCentreCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowReceiverCentreCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_CMR_EMIT' (state, payload) {
    state.local.isShowCreationDateTimeCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowCreationDateTimeCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_CMR_EMIT' (state, payload) {
    state.local.isShowStatusCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowStatusCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_CMR_EMIT' (state, payload) {
    state.local.isShowServiceCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowServiceCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SEND_DATE_CMR_EMIT' (state, payload) {
    state.local.isShowSendDateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSendDateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TRANSPORTIST_CMR_EMIT' (state, payload) {
    state.local.isShowTransportistCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowTransportistCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  
  // Columnas lineas emitidas
  'IS_SHOW_ITEMCODE_CMR_EMIT' (state, payload) {
    state.local.isShowItemCodeLinesCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowItemCodeLinesCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
   
}

export default {
  state,
  getters,
  actions,
  mutations
}
